// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__7FJBr","email":"Contact_email__kGdLE","letter":"Contact_letter__0AJA-"};